module.exports = require('./helpers/bundle-url').getBundleURL('dHWTq') + "logo-dark.a922e36b.svg";